import { Grid, Icon, Input, InputOnChangeData, Popup } from "semantic-ui-react";
import { getFeatureAvailabilityStatus } from "../../../../../app_shared_functions";

const MTUStatus = ({
  zoneId,
  value,
  onChange,
}: {
  zoneId: number;
  value: string;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    data: InputOnChangeData,
  ) => void;
}) => {
  const isUnsupported = getFeatureAvailabilityStatus({
    feature: "MTU",
    zoneId,
    component: "Create Network",
  });

  if (isUnsupported) {
    return (
      <Grid.Column
        textAlign="left"
        width={16}
        className="margin-top-20 flex vcenter default-height"
      >
        <h5 className="italic">
          <Icon
            name="warning sign"
            color="grey"
            className="margin-right-half"
          />
          {isUnsupported.description}
        </h5>
      </Grid.Column>
    );
  }

  return (
    <>
      <Grid.Column
        textAlign="left"
        width={8}
        className="margin-top-20 flex vcenter"
      >
        <h5>
          MTU
          <Popup
            trigger={
              <Icon
                name="warning circle"
                color="grey"
                size="small"
                className="margin-left-10"
              />
            }
          >
            Minimum value is 68 for IPv4, and 1280 for IPv6
          </Popup>
        </h5>
      </Grid.Column>
      <Grid.Column textAlign="left" width={8} className="margin-top-20">
        <Input
          value={value}
          name="mtu"
          className="select-box full"
          onChange={onChange}
        />
      </Grid.Column>
    </>
  );
};

export default MTUStatus;
